import { render, staticRenderFns } from "./CasePolicyDocusign.vue?vue&type=template&id=ba383cb0&scoped=true&"
import script from "./CasePolicyDocusign.vue?vue&type=script&lang=ts&"
export * from "./CasePolicyDocusign.vue?vue&type=script&lang=ts&"
import style0 from "./CasePolicyDocusign.vue?vue&type=style&index=0&id=ba383cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba383cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
